import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  dialogContainer: {
    width: '512px',
    overflow: 'hidden',
    borderRadius: '8px',
  },

  content: {
    padding: '33px 36px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
  },

  tickIcon: {
    color: (props) => props.accentColor,
    fontSize: 51,
  },

  textbox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '3px',
  },

  successTitle: {
    marginTop: '8px',
    fontWeight: 600,
    textAlign: 'center',
  },

  okButton: {
    backgroundColor: (props) => props.accentColor,
    width: '96px',
    height: '43px',
    fontSize: '16px',
    marginTop: '10px',
    '&:hover': {
      backgroundColor: (props) => props.accentColor,
    },
  },

  buttonRow: {
    display: 'flex',
    width: '100%',
    gap: '10px',
    marginTop: '10px',
  },

  secondaryButton: {
    flex: 1,
    padding: '12px 24px',
    borderRadius: 4,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.divider}`,
    fontSize: 13,
    fontWeight: 600,
    letterSpacing: '.04em',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: theme.palette.grey[100],
    },
  },

  primaryButton: {
    flex: 1,
    padding: '12px 24px',
    borderRadius: 4,
    backgroundColor: (props) => props.confirmButtonColor,
    color: '#fff',
    fontSize: 13,
    fontWeight: 600,
    letterSpacing: '.04em',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: (props) => props.confirmButtonColor,
    },
  },
});

export default styles;
export const useStyles = makeStyles(styles);
